import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Title = styled.div`
  ${tokens.text('header3')};
  overflow: auto;
  margin-bottom: ${tokens.spacer.x1};
`;
